import { LoadingLine } from '@enter/core';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { Navigate } from 'react-router-dom';
import { IInjectedRootStore } from 'stores';
import * as S from './private-route.styles';

interface IPrivateRouteProps extends Partial<IInjectedRootStore> {
    children: React.ReactElement;
}

interface IPrivateRouteState {
    verified: boolean;
}

@inject('rootStore')
@observer
export class PrivateRoute extends React.Component<IPrivateRouteProps, IPrivateRouteState> {
    constructor(props: IPrivateRouteProps) {
        super(props);
        this.state = {
            verified: false,
        };
    }
    public render(): React.ReactElement {
        return this.state.verified ? (
            this.renderComponentOrRedirect()
        ) : (
            this.renderProgress()
        );
    }
    public async componentDidMount(): Promise<void> {
        await this.injected.rootStore.checkSession();
        this.setState({ verified: true });
    }
    private get injected(): IInjectedRootStore {
        return this.props as IInjectedRootStore;
    }
    private get isExpired(): boolean {
        return this.injected.rootStore.isExpiredSession();
    }
    private readonly renderComponentOrRedirect = (): React.ReactElement => {
        return !this.isExpired ? this.props.children : <Navigate to="/redirect" replace />;
    };
    private readonly renderProgress = (): React.ReactElement => {
        const timeout = 15 * 1000;
        return (
            <S.Progress>
                <LoadingLine timeout={timeout} />
            </S.Progress>
        );
    };
}
